import { render } from "./MetaManager.vue?vue&type=template&id=5f54d996"
import script from "./MetaManager.vue?vue&type=script&lang=js"
export * from "./MetaManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__